import { render, staticRenderFns } from "./labelTag.vue?vue&type=template&id=5d64ac76&scoped=true"
import script from "./labelTag.vue?vue&type=script&lang=js"
export * from "./labelTag.vue?vue&type=script&lang=js"
import style0 from "./labelTag.vue?vue&type=style&index=0&id=5d64ac76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64ac76",
  null
  
)

export default component.exports